import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24ec93e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "admin-app",
  class: "admin-card"
}
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { for: "admin_contact" }
const _hoisted_4 = ["value"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { for: "max_users" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "user-limit-help" }
const _hoisted_9 = { class: "info-box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-info-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_11 = { for: "max_single_file_size" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { for: "max_zip_file_size" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { for: "gpx_limit_import" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 1,
  class: "form-buttons"
}
const _hoisted_18 = {
  class: "confirm",
  type: "submit"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 2,
  class: "form-buttons"
}

import {
    ComputedRef,
    computed,
    reactive,
    withDefaults,
    onBeforeMount,
    toRefs,
  } from 'vue'
  import { useRouter } from 'vue-router'

  import { ROOT_STORE } from '@/store/constants'
  import { TAppConfig, TAppConfigForm } from '@/types/application'
  import { useStore } from '@/use/useStore'
  import { getFileSizeInMB } from '@/utils/files'

  interface Props {
    appConfig: TAppConfig
    edition?: boolean
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    appConfig: null,
    edition: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { appConfig: TAppConfig, edition: boolean }

  
  const { edition } = toRefs(props)

  const store = useStore()
  const router = useRouter()

  const appData: TAppConfigForm = reactive({
    admin_contact: '',
    max_users: 0,
    max_single_file_size: 0,
    max_zip_file_size: 0,
    gpx_limit_import: 0,
  })
  const errorMessages: ComputedRef<string | string[] | null> = computed(
    () => store.getters[ROOT_STORE.GETTERS.ERROR_MESSAGES]
  )

  onBeforeMount(() => {
    if (props.appConfig) {
      updateForm(props.appConfig)
    }
  })

  function updateForm(appConfig: TAppConfig) {
    Object.keys(appData).map((key) => {
      ['max_single_file_size', 'max_zip_file_size'].includes(key)
      ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        (appData[key] = getFileSizeInMB(appConfig[key]))
      : // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        (appData[key] = appConfig[key])
    })
  }
  function onCancel() {
    updateForm(props.appConfig)
    store.commit(ROOT_STORE.MUTATIONS.EMPTY_ERROR_MESSAGES)
    router.push('/admin/application')
  }
  function onSubmit() {
    const formData: TAppConfigForm = Object.assign({}, appData)
    formData.max_single_file_size *= 1048576
    formData.max_zip_file_size *= 1048576
    store.dispatch(ROOT_STORE.ACTIONS.UPDATE_APPLICATION_CONFIG, formData)
  }

return (_ctx: any,_cache: any) => {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Card, null, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('admin.APP_CONFIG.TITLE')), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("form", {
          class: "admin-form",
          onSubmit: _withModifiers(onSubmit, ["prevent"])
        }, [
          _createElementVNode("label", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.$t('admin.APP_CONFIG.ADMIN_CONTACT')) + ": ", 1),
            (!_unref(edition) && !_unref(appData).admin_contact)
              ? (_openBlock(), _createElementBlock("input", {
                  key: 0,
                  class: "no-contact",
                  value: _ctx.$t('admin.APP_CONFIG.NO_CONTACT_EMAIL'),
                  disabled: ""
                }, null, 8, _hoisted_4))
              : _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 1,
                  id: "admin_contact",
                  name: "admin_contact",
                  type: "email",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(appData).admin_contact) = $event)),
                  disabled: !_unref(edition)
                }, null, 8, _hoisted_5)), [
                  [_vModelText, _unref(appData).admin_contact]
                ])
          ]),
          _createElementVNode("label", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.$t('admin.APP_CONFIG.MAX_USERS_LABEL')) + ": ", 1),
            _withDirectives(_createElementVNode("input", {
              id: "max_users",
              name: "max_users",
              type: "number",
              min: "0",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(appData).max_users) = $event)),
              disabled: !_unref(edition)
            }, null, 8, _hoisted_7), [
              [_vModelText, _unref(appData).max_users]
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, [
              _hoisted_10,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('admin.APP_CONFIG.MAX_USERS_HELP')), 1)
            ])
          ]),
          _createElementVNode("label", _hoisted_11, [
            _createTextVNode(_toDisplayString(_ctx.$t('admin.APP_CONFIG.SINGLE_UPLOAD_MAX_SIZE_LABEL')) + ": ", 1),
            _withDirectives(_createElementVNode("input", {
              id: "max_single_file_size",
              name: "max_single_file_size",
              type: "number",
              step: "0.1",
              min: "0",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(appData).max_single_file_size) = $event)),
              disabled: !_unref(edition)
            }, null, 8, _hoisted_12), [
              [_vModelText, _unref(appData).max_single_file_size]
            ])
          ]),
          _createElementVNode("label", _hoisted_13, [
            _createTextVNode(_toDisplayString(_ctx.$t('admin.APP_CONFIG.ZIP_UPLOAD_MAX_SIZE_LABEL')) + ": ", 1),
            _withDirectives(_createElementVNode("input", {
              id: "max_zip_file_size",
              name: "max_zip_file_size",
              type: "number",
              step: "0.1",
              min: "0",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(appData).max_zip_file_size) = $event)),
              disabled: !_unref(edition)
            }, null, 8, _hoisted_14), [
              [_vModelText, _unref(appData).max_zip_file_size]
            ])
          ]),
          _createElementVNode("label", _hoisted_15, [
            _createTextVNode(_toDisplayString(_ctx.$t('admin.APP_CONFIG.MAX_FILES_IN_ZIP_LABEL')) + ": ", 1),
            _withDirectives(_createElementVNode("input", {
              id: "gpx_limit_import",
              name: "gpx_limit_import",
              type: "number",
              min: "0",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(appData).gpx_limit_import) = $event)),
              disabled: !_unref(edition)
            }, null, 8, _hoisted_16), [
              [_vModelText, _unref(appData).gpx_limit_import]
            ])
          ]),
          (_unref(errorMessages))
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 0,
                message: _unref(errorMessages)
              }, null, 8, ["message"]))
            : _createCommentVNode("", true),
          (_unref(edition))
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("button", _hoisted_18, _toDisplayString(_ctx.$t('buttons.SUBMIT')), 1),
                _createElementVNode("button", {
                  class: "cancel",
                  onClick: _withModifiers(onCancel, ["prevent"])
                }, _toDisplayString(_ctx.$t('buttons.CANCEL')), 9, _hoisted_19)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("button", {
                  class: "confirm",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.$router.push('/admin/application/edit')), ["prevent"]))
                }, _toDisplayString(_ctx.$t('buttons.EDIT')), 1),
                _createElementVNode("button", {
                  class: "cancel",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.$router.push('/admin')), ["prevent"]))
                }, _toDisplayString(_ctx.$t('admin.BACK_TO_ADMIN')), 1)
              ]))
        ], 40, _hoisted_2)
      ]),
      _: 1
    })
  ]))
}
}

})